/* eslint-disable max-len */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import emptyFunction from '@avtechsoftware/ra-javascript-utilities/src/utilities/EmptyFunction';
import BasicOrderInformation from '../../BasicOrderInformartion/BasicOrderInformation';
import CrmOrderDetails from '../../../../classes/CrmOrderDetails';
import RegisterSignInBox from '../../../orders_quotes_shared/RegisterSignInBox/RegisterSignInBox';
import {
  generateResourceURLFromParam,
} from '../../../../utility/orderAndQuoteUtil';

function NotAuthenticatedOrderScreen({
  order, loadError, shipmentList, onGetTrackingDetails,
}) {
  const location = useLocation();
  const history = useHistory();
  const params = useParams();
  const memoizedStatus = useMemo(() => order.shippingStatus,
    [order.shipmentList, order.shippingTimestamp]);
  const forceSignInView = new URLSearchParams(location.search).get('ref') === 'login';

  const onPayAsGuest = () => {
    const { id } = params;
    history.push(`/p/order/pay-as-guest/ORD-${generateResourceURLFromParam(id)}`);
  };

  return (
    <div>
      <div className="row">
        <div className="col-auto mb-2">
          <BasicOrderInformation
            orderNumber={order.orderNumber}
            orderStatus={memoizedStatus}
            billingStatus={order.paymentType}
            orderPlacedOn={order.createdAtDisplay}
            shippingMethod={`${order.shipCarrier} ${order.shipMethod}`}
            loadError={loadError}
            shipmentList={shipmentList}
            onTrackClick={onGetTrackingDetails}
          />
        </div>
        {!loadError && (
          <div className="col-xs-12 col-sm-10 col-md-6 col-lg-5">
            <RegisterSignInBox
              referrer={`ord-${order.id}`}
              isOrder
              isClosed={order.billingStatus && order.billingStatus === 'Closed'}
              forceSignIn={forceSignInView}
              onPayAsGuest={onPayAsGuest}
              isPayable={
                order.needsPayment
              }
            />
          </div>
        )}
      </div>
    </div>
  );
}

NotAuthenticatedOrderScreen.propTypes = {
  order: PropTypes.shape(CrmOrderDetails).isRequired,
  loadError: PropTypes.bool.isRequired,
  shipmentList: PropTypes.arrayOf(PropTypes.shape({ trackingNumber: PropTypes.string })),
  onGetTrackingDetails: PropTypes.func,
};

NotAuthenticatedOrderScreen.defaultProps = {
  shipmentList: [],
  onGetTrackingDetails: emptyFunction,
};

export default NotAuthenticatedOrderScreen;
